export default class Image {
    src: string;
    caption: string;
    alt: string;
    thumbnail: string;

    /**
     * @param src
     * @param caption
     * @param alt
     * @param thumbnail
     */
    constructor(src: string, caption: string, alt: string, thumbnail: string) {
        this.src = src;
        this.caption = caption || src || alt
        this.alt = alt || src;
        this.thumbnail = thumbnail || src || alt;
    }
}


// WEBPACK FOOTER //
// ./src/Models/imageModels/Image.ts